"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var NewSecurity = function NewSecurity() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "16",
    height: "20",
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.99997 19.4807C5.83716 18.8909 4.04646 17.6179 2.62787 15.6615C1.20929 13.7051 0.5 11.5179 0.5\n9.09995V3.34613L7.99997 0.538452L15.5 3.34613V9.09995C15.5 11.5179 14.7907 13.7051 13.3721\n15.6615C11.9535 17.6179 10.1628 18.8909 7.99997 19.4807ZM7.99997 17.9C9.61664 17.4 10.9666 16.4125\n12.05 14.9375C13.1333 13.4625 13.7666 11.8166 13.95 9.99995H7.99997V2.13458L1.99997\n4.37495V9.54033C1.99997 9.66341 2.01664 9.81662 2.04997 9.99995H7.99997V17.9Z",
    fill: "#6E6D71"
  }));
};
var _default = NewSecurity;
exports.default = _default;